<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">Acknowledgements</p>
<p class="noindent">While I have put many years of research into this book, certain people have helped make this book possible. This includes a special group of local historians who influenced me. They are: Julia Cook Guice, Mary Louise Adkinson, Murella Hebert Powell, Kat Bergeron and Dr. Val Husley.</p>
<p class="indent">In 1985, I became involved with the Maritime and Seafood Industry Museum located in Biloxi. It developed into a first-class museum, but in 2005, Hurricane Katrina destroyed the building and all the exhibits less than one year after a total remodeling of and addition to the museum. Today, it is located in a new building. The museum’s records, documents and pictures played a big part in the research for this book. Thank-you to Alan Santa Cruz and Lynn and Sandra Paterson, who allowed their collection of Gulf Coast postcards to become an important part of this book. Thank-you to Bettie Fore for allowing her White family photographs to become an important part of Chapter 17.</p>
<p class="indent">The local history and genealogy department of the Harrison County Library System also deserves special thanks.</p>
<p class="indent">I would also like to thank The History Press for recognizing Biloxi’s lost and forgotten history through the printing of this book.</p>
<p class="indent">Last but not least, I have a very special appreciation for my wife, Virginia, who edited my work and kept me straight.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgements.vue?0b495d65